/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFriendInviteBody
 */
export interface CreateFriendInviteBody {
    /**
     * Optional email to send targeted invite. If omitted, returns a shareable link only.
     * @type {string}
     * @memberof CreateFriendInviteBody
     */
    email?: string;
}

/**
 * Check if a given object implements the CreateFriendInviteBody interface.
 */
export function instanceOfCreateFriendInviteBody(value: object): value is CreateFriendInviteBody {
    return true;
}

export function CreateFriendInviteBodyFromJSON(json: any): CreateFriendInviteBody {
    return CreateFriendInviteBodyFromJSONTyped(json, false);
}

export function CreateFriendInviteBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFriendInviteBody {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function CreateFriendInviteBodyToJSON(json: any): CreateFriendInviteBody {
    return CreateFriendInviteBodyToJSONTyped(json, false);
}

export function CreateFriendInviteBodyToJSONTyped(value?: CreateFriendInviteBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

